
import BaseField from '@/views/Company/Settings/Narrowcasting/Collections/BaseField.vue'
import { Component } from 'vue-property-decorator'

@Component
export default class BaseMinMaxField extends BaseField {
    minValue: number = null
    maxValue: number = null

    applyInitialValues() {
        if (this.value) {
            this.minValue = this.value.min ?? null
            this.maxValue = this.value.max ?? null
        }
    }

    get fieldValues(): object|string[] {
        return {
            min: this.minValue,
            max: this.maxValue,
        }
    }
}
